/**
 * NotesCount.js
 * Created by calhosh on 11/10/2020.
 */
import React, {useEffect, useState, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import {isNullOrUndefined, labels} from '../../../util/utils';
import {entityTypes} from '../../../util/uiconstants';
import {toggleModal} from '../ReactiveReviewModal';
import {openReviewNotesModal} from '../../../actions/NotesModal/rnhnotedetailaction';
import {setIsModalOpen} from '../../../actions/setismodalopen';
import {clearErrors} from '../../../actions/erroractions';
import Button from '../BaseComponentWrappers/MotifButton';
import {IconoirPlusCircle, IconoirPageEdit} from '@ey-xd/motif-icon';
import Badge from '../BaseComponentWrappers/MotifBadge';
import Icon from '../BaseComponentWrappers/MotifIcon';
import CanvasFormOnlyReviewNotes from './CanvasFormOnlyReviewNotes';

export default function NotesCount(props) {
	const {
		document,
		engagementId,
		viewKey,
		entityUId,
		isCustomIcon,
		isDisabled,
		documentId,
		customLabel,
		customZeroCount,
		externalCount,
		leftNavCounter
	} = props;
	const dispatch = useDispatch();
	const [noteCount, setNoteCount] = useState(document?.engagementReviewNoteCount || null);
	const [showCanvasFormNotesModal, setShowCanvasFormNotesModal] = useState(false);
	const rnhNoteDetail = useSelector((state) => state.rnhNoteDetail);

	useEffect(() => {
		if (document) {
			setNoteCount(document?.engagementReviewNoteCount);
		}
	}, [document]);

	function openNotesModal(event) {
		event.preventDefault();
		event.stopPropagation();

		if (isDisabled) {
			return false;
		}

		if (!rnhNoteDetail.notesModalOpen) {
			if (viewKey === 'FORM_BODY_QUICK_REFERENCE') {
				setShowCanvasFormNotesModal(!showCanvasFormNotesModal);
				dispatch(openReviewNotesModal());
			} else {
				dispatch(clearErrors())
					.then(() => dispatch(openReviewNotesModal()))
					.then(() => dispatch(setIsModalOpen(true)));
				toggleModal({
					parentName: 'documentNotes',
					document: document,
					entityId: document.id,
					entityUId: entityUId,
					viewKey: viewKey,
					engagementId: engagementId,
					entityType: entityTypes.Document,
					reviewnoteType: 2,
					messagePlaceHolder: labels.placeholderForSearch,
					isAresView: props.isAresView
				});
			}
		}
	}

	const getNotesCountLabel = useCallback(() => {
		let _count = !isNullOrUndefined(externalCount) ? externalCount : noteCount;
		return _count === 0 && customZeroCount ? customZeroCount : <Badge count={_count} />;
	}, [externalCount, noteCount, customZeroCount]);

	return (
		<>
			<StyledNotesCount
				className={`StyledNotesCount notesControl ${leftNavCounter ? 'leftNavCounter' : ''}
						${isCustomIcon ? 'isCustomIcon' : ''}`}
			>
				{leftNavCounter ? (
					<Button
						title={labels.comments}
						variant="ghost"
						onClick={openNotesModal}
						showIcon
						showLabel
						buttonLabel={customLabel}
					>
						{getNotesCountLabel()}
						<Icon className="NotesSVGIcon" src={IconoirPageEdit} title={labels.comments} />
					</Button>
				) : isCustomIcon ? (
					<button
						type="button"
						name="name"
						disabled={isDisabled}
						value={labels.comments}
						title={labels.comments}
						onClick={openNotesModal}
						className="bold-font secondaryBtn btn btn-default isCustomIcon"
					>
						<Icon className="NotesIconsImg" src={IconoirPageEdit} title={labels.comments} />
						{customLabel && <span className="NotesCountLabels">{customLabel}</span>}
						<span className="NotesCountLabels">{getNotesCountLabel()}</span>
					</button>
				) : (
					<Button
						variant="ghost"
						title={labels.comments}
						iconTitle={labels.comments}
						onClick={openNotesModal}
						iconSource={IconoirPlusCircle}
						showIcon={isNullOrUndefined(noteCount) || noteCount === 0}
						showLabel={!isNullOrUndefined(noteCount) && noteCount > 0}
						buttonLabel={noteCount}
						disabled={isDisabled}
					/>
				)}
			</StyledNotesCount>
			{showCanvasFormNotesModal && (
				<CanvasFormOnlyReviewNotes
					document={document}
					engagementId={engagementId}
					viewKey={viewKey}
					setShowNotesModal={setShowCanvasFormNotesModal}
					entityUId={entityUId}
				/>
			)}
		</>
	);
}

const StyledNotesCount = styled.section`
	display: inline-flex;
	.btn-default {
		background-image: none;
		border-radius: 0;
		box-sizing: border-box;
		cursor: pointer;
		display: inline-block;
		font-size: var(--px-14);
		line-height: var(--px-14);
		margin: var(--px-5) 0 0 0;
		padding: var(--px-5);
		text-align: center;
		touch-action: manipulation;
		user-select: none;
		vertical-align: middle;
		white-space: nowrap;
		background-color: transparent;
		border-color: transparent;
		font-weight: 100;
		span {
			color: var(--neutrals-900);
			vertical-align: top;
			display: inline-block;
			padding-top: var(--px-3);
			svg {
				fill: var(--neutrals-900);
			}
			&:last-child {
				padding-left: var(--px-5);
			}
		}
		&:hover,
		&:focus,
		&:active,
		&:active:focus {
			background-color: transparent;
			border-color: transparent;
			box-shadow: none;
			outline: none;
		}
	}
	.no-note-selected {
		display: flex;
		width: 100%;
		height: 100%;
		justify-content: center;
		align-items: center;
		.empty-note-details-text {
			margin-left: var(--px-10);
		}
	}
	.motif-text-alt-button {
		font-size: var(--px-12);
		gap: 0;
	}
	.motif-button {
		span {
			width: var(--px-20);
		}
	}
`;
